import { useState } from 'react';
import {
  getDisplayScale,
  nextDisplayScale,
  setDisplayScale,
  type DisplayScale,
} from '../system/displayScale';

const LABELS: Record<DisplayScale, string> = {
  auto: 'Display size: automatic',
  comfort: 'Display size: comfort',
  standard: 'Display size: standard',
};

/**
 * Persisted density override (blueprint §3 — docs/redesign/DESIGN_BLUEPRINT.md).
 * Cycles auto → comfort → standard; the CSS hides it on phones, where browser
 * zoom is already native. The aria-label always names the CURRENT state so
 * activation is predictable.
 */
export function DisplayScaleToggle() {
  const [scale, setScale] = useState<DisplayScale>(() => getDisplayScale());

  return (
    <button
      type="button"
      className="rd-display-scale-toggle"
      aria-label={`${LABELS[scale]}. Activate to change.`}
      onClick={() => {
        const next = nextDisplayScale(scale);
        setDisplayScale(next);
        setScale(next);
      }}
    >
      {scale === 'auto' ? 'Auto size' : scale === 'comfort' ? 'Comfort' : 'Standard'}
    </button>
  );
}
